module.exports = __webpack_public_path__ + "bm.e28367a1.svg";